import { Popover } from "antd";
import Sustainability from "../Sustainability/Sustainability";

export function SustainabilityIcon({ sustainability, iconSize, leftMargin }) {
  const hoverSustainabilityContent = (sustainability) => (
    <div>
      <Sustainability sustainability={sustainability} iconWidth={60} />
    </div>
  );

  return (
    <div
      className="ahp-store-stamp"
      style={{
        // left: leftMargin,
        ...iconSize,
      }}
    >
      <Popover
        overlayStyle={{
          width: 320,
          height: 320,
          overflow: "scroll",
        }}
        content={hoverSustainabilityContent(sustainability)} // title="Hover title"
        trigger="hover" // visible={this.state.hovered}
        // onVisibleChange={this.handleHoverChange}
      >
        <img
          src="https://aldeiashistoricasdeportugal.com/wp-content/uploads/2022/02/SDG-Wheel_WEB.png"
          alt="SDG logo"
          width={iconSize.width * 0.6}
        />
      </Popover>
    </div>
  );
}
